import React from 'react'

const CodeSnippet = ({ codeSnippet }) => {
    return (
        <code style={{ color: '#c7254e', border: '1px #eee solid', padding: '2px 4px', borderRadius: '4px', backgroundColor: '#f9f7fb', }}>
            {codeSnippet}
        </code>
    )
}

export default CodeSnippet